<template>
    <div class="flex flex-row flex-nowrap bg-gray-50 rounded-r-lg border-l border-l-gray-200 w-max justify-end">
        <div class="self-center pl-2 py-2 pr-1 flex flex-col items-center gap-[clamp(0.25rem,0.625rem,0.75rem)]">
            <div class="flex flex-row items-center gap-1 text-sm/none font-light text-gray-500">
                <StarFilledIcon class="size-4" /> {{ $t('main-variant') }}
            </div>

            <div class="text-3xl/none">
                <AllocationVariantIndex text-size="Inherit" :index="props.index" />
            </div>

            <div class="flex flex-row items-center gap-2 pt-0.5">
                <LinkButton
                    class="text-gray-700"
                    size="Small"
                    variant="Transparent-Light"
                    :icon-description="$t('open-allocation-variant-detail-page')"
                    :open-in-new-tab="true"
                    :to="props.linkTarget"
                >
                    <template #icon>
                        <ExternalLinkIcon class="size-4.5" />
                    </template>
                </LinkButton>

                <slot name="main-variant-status" />
            </div>
        </div>

        <slot name="tiles" />
    </div>
</template>

<script setup lang="ts">
import { RouteLocationRaw } from 'vue-router';
import AllocationVariantIndex from '../AllocationVariantIndex/AllocationVariantIndex.vue';
import LinkButton from '../Button/LinkButton.vue';
import ExternalLinkIcon from '../Icon/ExternalLinkIcon.vue';
import StarFilledIcon from '../Icon/StarFilledIcon.vue';

type MainVariantTileWrapperProps = {
    index: number;
    linkTarget: RouteLocationRaw;
};

const props = defineProps<MainVariantTileWrapperProps>();
</script>
